// extracted by mini-css-extract-plugin
export default {"modal":"model-action_modal__k2EmU"};